export abstract class WorklistTagsProvider {
    abstract getAvailableTags(): Promise<any[]>;
    abstract isAllowedToChangeTags(worklist): Promise<boolean>;
    abstract saveToggleTag(worklistId, tag, worklist): Promise<any>;
}
